import styles from "./Designer.module.css";

const SectionTitle = ({ title, subtitle }) => (
    <div className={styles.wizardSectionHeader}>
        <h4 className={styles.wizardSectionTitle}>{title}</h4>
        {subtitle ? <p className={styles.wizardSectionSubtitle}>{subtitle}</p> : null}
    </div>
);

const PartSelectionView = ({
    partCards = [],
    activePartKey,
    onSelectActivePart,
    onTogglePart,
}) => (
    <section className={styles.sectionCard}>
        <SectionTitle
            title="Elegí qué parte querés editar"
            subtitle="Activá o desactivá partes opcionales y elegí una parte para continuar."
        />
        <div className={styles.partSelectionGrid}>
            {partCards.map((part) => {
                const isActive = activePartKey === part.key;
                const statusClass = part.complete ? styles.partStatusComplete : styles.partStatusPending;
                return (
                    <button
                        key={`part-card-${part.key}`}
                        type="button"
                        className={`${styles.partSelectionCard} ${isActive ? styles.partSelectionCardActive : ""}`}
                        onClick={() => onSelectActivePart(part.key)}
                    >
                        <div className={styles.partSelectionHead}>
                            <div>
                                <div className={styles.partSelectionName}>{part.label}</div>
                                <div className={styles.partSelectionMeta}>
                                    {part.parentLabel ? `Depende de ${part.parentLabel}` : "Parte principal"}
                                </div>
                            </div>
                            <label
                                className={styles.switch}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <input
                                    type="checkbox"
                                    checked={part.selected}
                                    disabled={part.required}
                                    onChange={(e) => onTogglePart(part.key, e.target.checked)}
                                />
                                <span className={styles.slider}></span>
                            </label>
                        </div>

                        <div className={styles.partSelectionBadges}>
                            {part.required ? <span className={styles.partBadgeRequired}>Requerida</span> : <span className={styles.partBadgeOptional}>Opcional</span>}
                            <span className={`${styles.partBadgeStatus} ${statusClass}`}>
                                {part.complete ? "Lista" : `Falta: ${part.missing.join(", ")}`}
                            </span>
                        </div>
                    </button>
                );
            })}
        </div>
        {partCards.length === 0 ? <div className={styles.emptyState}>No hay partes disponibles en esta prenda.</div> : null}
    </section>
);

export default PartSelectionView;
